import { lazyload } from './lazyload/lazyload'
import { inputListener } from './input-listener'
import { dragTrigger } from './drag-trigger'
import { tabGroup } from './tab-group'
import { roomDetailsBookNowButton } from './roomDetailsBookNowButton'
import { currency } from './currency'
import { elementInjector } from './element-injector'

export default [
  lazyload,
  inputListener,
  dragTrigger,
  tabGroup,
  roomDetailsBookNowButton,
  currency,
  elementInjector
]
